<script setup>
import { Link } from '@inertiajs/vue3';
</script>

<template>
    <Link :href="'/'">
        <img :src="asset('images/DivertAlertHome-03.png')" alt="Logo" >
    </Link>
</template>
